export const PKG_NAME = "@hpcc-js/api";
export const PKG_VERSION = "2.14.2";
export const BUILD_VERSION = "2.108.6";
